import {Component, OnInit} from '@angular/core';
import {AlertService, GroupService, UserService} from "../services";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import {DeviceService} from "../services/device.service";
import {DeviceGroupService} from "../services/deviceGroup.service";

import { locale as polish } from './i18n/pl';
import { locale as english } from './i18n/en';
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";
import {ComponentTitleService} from "../services/componentTitle.service";

@Component({
    templateUrl: './deviceForm.component.html',
    styleUrls: ['./deviceForm.component.scss']
})

export class DeviceFormComponent implements OnInit {

    form: FormGroup;
    loading = false;
    submitted = false;
    id: string;
    cardNumber: string;
    isAddMode: boolean;
    deviceGroups: any[];

    constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private userService: UserService,
        private alertService: AlertService,
        private deviceService: DeviceService,
        private deviceGroupService: DeviceGroupService,
        private translationLoader: FuseTranslationLoaderService,
        private componentTitleService: ComponentTitleService
    ) {
        this.translationLoader.loadTranslations(polish, english);

        componentTitleService.clearTitle();
        componentTitleService.addPart('Devices');
    }

    ngOnInit() {
        this.id = this.route.snapshot.params['id'];
        this.isAddMode = !this.id;

        if (this.isAddMode) {
            this.componentTitleService.addPart('New');
        } else {
            this.componentTitleService.addPart('Edit');
        }

        this.deviceGroupService.getAll().pipe(first())
            .subscribe( res => {
                    this.deviceGroups = res;
                },
                error => {
                    this.alertService.error(error);
                })

        this.form = this.formBuilder.group({
            name: ['', Validators.required],
            serialNumber: ['', Validators.required],
            active: [''],
            description: [''],
            registered: [''],
            deviceGroup: [''],
        });

        if (!this.isAddMode) {
            this.deviceService.getById(this.id)
                .pipe(first())
                .subscribe(x => {
                    this.f.name.setValue(x.name);
                    this.f.active.setValue(x.active);
                    this.f.description.setValue(x.description);
                    this.f.registered.setValue(x.registered);
                    this.f.serialNumber.setValue(x.serialNumber);
                    this.f.deviceGroup.setValue(x.deviceGroup.id);
                }, error => {
                    this.alertService.error(error);
                });
        }
    }

    // convenience getter for easy access to form fields
    get f() { return this.form.controls; }

    onSubmit() {
        this.submitted = true;

        // reset alerts on submit
        this.alertService.clear();

        // stop here if form is invalid
        if (this.form.invalid) {
            return;
        }

        this.loading = true;

        if (this.isAddMode) {
            this.createDevice();
        } else {
            this.updateDevice();
        }
    }

    private createDevice() {
        this.deviceService.create(this.form.value)
            .pipe(first())
            .subscribe(
                data => {
                    this.alertService.success('Device added successfully', { keepAfterRouteChange: true });
                    this.router.navigate(['.', { relativeTo: this.route }]);
                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                });
    }

    private updateDevice() {
        this.deviceService.update(this.id, this.form.value)
            .pipe(first())
            .subscribe(
                data => {
                    this.alertService.success('Update successful', { keepAfterRouteChange: true });
                    this.router.navigate(['..', { relativeTo: this.route }]);
                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                });
    }
}
